$('.cbd-tab li a').on('click', function(){
    var target = $(this).attr('data-rel');
 $('.cbd-tab li a').removeClass('active');
    $(this).addClass('active');
    $("#"+target).fadeIn('slow').siblings(".cbd-tab-img").hide();
    return false;
});
// 
$('.reviews-slider').owlCarousel({
    loop:true,
    margin:10,
    nav:false,
    dots:true,
    responsive:{
        0:{
            items:1
        },
        600:{
            items:2
        },
        1000:{
            items:3
        }
    }
});
// 

//    
   $('.coas-read-tab-list li a').on('click', function(){
    var target = $(this).attr('data-rel');
 $('.coas-read-tab-list li a').removeClass('active');
    $(this).addClass('active');
    $("#"+target).fadeIn('slow').siblings(".coas-read-img").hide();
    return false;
});
// 
$('.lab-tab-list li a').on('click', function(){
    var target = $(this).attr('data-rel');
 $('.lab-tab-list li a').removeClass('active');
    $(this).addClass('active');
    $("#"+target).fadeIn('slow').siblings(".lab-tab-data").hide();
    return false;
});
// 
$('.report-tab-list li a').on('click', function(){
    var target = $(this).attr('data-rel');
//  $('.report-tab-list li a').removeClass('active');
    $(this).addClass('active').parent().siblings().children().removeClass('active');
    $("#"+target).fadeIn('slow').siblings(".report-tab-img").hide();
    return false;
});
// 
$('.table-tab-list li a').on('click', function(){
    var target = $(this).attr('data-rel');
 $('.table-tab-list li a').removeClass('active');
    $(this).addClass('active');
    $("#"+target).fadeIn('slow').siblings(".table-tab-data").hide();
    return false;
});

$('.faq-flex').click(function(){
    $(this).children('.faq-answer').slideToggle().closest('.faq-flex').siblings().children('.faq-answer').slideUp();
    $(this).toggleClass('active').siblings().removeClass('active');
})